import { getLeFEOrigin } from '@utils/util';

export const OfflineOrderManagerLeFE = () => (
    <iframe className="admin-iframe" title="线下订单" src={`${getLeFEOrigin()}/#/app/admin/offline_order`} />
);
